import { ECG_CONSTANTS } from '../utils/ecg-constants';
import { TraceViewModel } from '../view-models/trace-viewmodel';
import { CaliperViewModel } from '../view-models/caliper-viewmodel';
import {
    ArrangementType,
    CaliperMode,
    Cultures,
    Format,
    GuidedComparisonType,
    PaperRate,
    TimeAlignment,
} from '../models/emuns';

export class MultiViewerState {
    studySpacing = ECG_CONSTANTS.STUDIES_SPACING;
    horizontalStudySpacing = ECG_CONSTANTS.HORIZONTAL_STUDIES_SPACING;
}

export class ViewerState {
    toolbarVisible: boolean = true;
}

export class CustomCommandState {
    visible: boolean = false;
    text: string = '';
    source: string = '';
}

export class ToolbarState {
    customCommandState = new CustomCommandState();
}

export class ChartState {
    arrangement: ArrangementType = ArrangementType.SixXTwo; //12x1 6x2 ....
    timeAlignment: TimeAlignment = TimeAlignment.Sequential;
    paperRate: PaperRate = PaperRate.mm25;
    format = Format.standard;
    fiducialPointsVisible = false;
    paperOpacity = 0.2;
    isFitBaseline = false;
    traceSpacing = ECG_CONSTANTS.TRACE_SPACING;
    guidedComparison: GuidedComparisonType = GuidedComparisonType.TraceToTrace; //tipo di confronto traccia traccia , sovrapposto , esame su esame...
    caliperMode = CaliperMode.single;
    zoomFactor: number = 1;
    printAsDisplayed = false;
}

export class SummaryState {
    visible = true;
}

export class DetailsState {
    visible = true;
    summaryState = new SummaryState();
}

export class EcgState {
    visualComparison = false;
    culture = Cultures.en_US;
    multiViewerState = new MultiViewerState();
    viewerState = new ViewerState();
    chartState = new ChartState();
    detailsState = new DetailsState();
    toolbarState = new ToolbarState();
}

export class CaliperMessage {
    private _trace: TraceViewModel;
    get trace() {
        return this._trace;
    }

    private _caliper: CaliperViewModel;
    get caliper() {
        return this._caliper;
    }

    constructor(trace: TraceViewModel, caliper: CaliperViewModel) {
        this._trace = trace;
        this._caliper = caliper;
    }
}
